module.exports = __webpack_public_path__ + "static/media/customize-dessert.da94c01b.png";